import { Routes, Route } from 'react-router-dom';
import Index from "./pages/Index";
import SearchEngine from "./pages/SearchEngine";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import HR from "./pages/HR";
import Training from "./pages/Training";
import Recruiters from "./pages/Recruiters";
import Individuals from "./pages/Individuals";
import RNCP from "./pages/RNCP";
import MetaRepository from "./pages/MetaRepository";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

const App = () => (
    <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/search-engine/" element={<SearchEngine />} />
        <Route path="/drh/" element={<HR />} />
        <Route path="/formations/" element={<Training />} />
        <Route path="/recruteurs/" element={<Recruiters />} />
        <Route path="/particuliers/" element={<Individuals />} />
        <Route path="/rncp-presentation/" element={<RNCP />} />
        <Route path="/meta-referentiel/" element={<MetaRepository />} />
        <Route path="/contact/" element={<Contact />} />
        <Route path="/mentions-legales/" element={<LegalNotice />} />
        <Route path="/politique-de-confidentialite/" element={<PrivacyPolicy />} />
        <Route path="/cgu/" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
);

export default App;
